module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('div', {
    staticClass: "flex flex-row items-center mb2"
  }, [_c('img', {
    staticClass: "img-responsive v-mid mr2 mb1",
    class: _vm.icon !== '' ? 'w-20-l' : '',
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f5 mb2 color-theme title-responsive"
  }, [_vm._v(_vm._s(_vm.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 color-theme title-responsive-neg"
  }, [_vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('span', {
    staticClass: "mb2 f6 inter"
  }, [_vm._v(_vm._s(_vm.brand) + " - " + _vm._s(_vm.model.trim() === '' ? _vm.type : _vm.model))]), _vm._v(" "), (_vm.serial) ? _c('div', [_c('div', {
    staticClass: "f6 gray inter mb1"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('device.serialnumber', {
    serialnumber: 'Serial Number'
  })) + "\n          ")]), _vm._v("\n          " + _vm._s(_vm.serial) + "\n        ")]) : _c('div', {
    staticClass: "f6 gray inter"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('device.noserialnumber', {
    noserialnumber: 'No serial number'
  })) + "\n        ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f91dc2b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceTile.vue
// module id = 1345
// module chunks = 0